import { createAction } from '@reduxjs/toolkit';

import { useAnimatedModal } from '@perpay-web/components/base/Modal/useAnimatedModal';
import { useModal } from '@perpay-web/components/base/Modal/useModal';
import { useActionObservableCallback } from '@perpay-web/hooks/useActionObservableCallback';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

export const biometricRegistrationFailedModalSetIsModalOpen = createAction(
    'BIOMETRIC_REGISTRATION_FAILED_MODAL::SET_IS_MODAL_OPEN',
);

const useBiometricRegistrationFailedModal = () => {
    const { isModalOpen, setIsModalOpen } = useModal();
    const {
        isAnimatedModalOpen,
        setIsAnimatedModalOpen,
        animatedModalClassName,
    } = useAnimatedModal({ isModalOpen, setIsModalOpen });

    return {
        isAnimatedModalOpen,
        setIsAnimatedModalOpen,
        animatedModalClassName,
    };
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const hook = useBiometricRegistrationFailedModal();

        useActionObservableCallback(
            hookAction$,
            biometricRegistrationFailedModalSetIsModalOpen().type,
            (value) => hook.setIsAnimatedModalOpen(value),
        );

        return <Context.Provider value={hook}>{children}</Context.Provider>;
    };

    return Provider;
};

export const [
    BiometricRegistrationFailedModalProvider,
    useBiometricRegistrationFailedModalContext,
] = createContextProvider(providerFactory);
